// shared/components/UIElements/HelpButton.jsx
import React, { useContext } from "react";
import { TutorialContext } from "../../context/tutorial-context";
import "./HelpButton.scss";

const HelpButton = ({ tutorialData, className = "" }) => {
  const { showTutorial } = useContext(TutorialContext);

  const handleClick = () => {
    showTutorial(tutorialData);
  };

  return (
    <button
      type="button"
      className={`help-button ${className}`}
      onClick={handleClick}
      aria-label="Ajuda"
      title="Ver tutorial"
    >
      ?
    </button>
  );
};

export default HelpButton;
